import { useEffect, useRef, useState } from 'react'
import { createModel } from 'hox'
import { TablePaginationConfig } from 'antd/es/table/interface'
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE } from '@/utils/constants'
import { IOrderDetail, IOrderSearchFields, orderService } from './orderService'
import useGlobalModel, { transPgToPagination } from '@/model/globalModel'
import { ISearchPage } from '@/types/AppTypes'
import { ModoulTypeList } from '@/types/TcoDs'
import { convertRes2Blob } from '@/utils/exportFile'
import { fleetService } from '@/views/base/fleet/fleetService'

export const useOrderModel = createModel(function () {
    const settingTypeList = ModoulTypeList
    /**
     * 列表
     */
    //列表数据源
    const [dataSource, setDataSource] = useState<IOrderDetail[]>([])
    //查询条件
    const [searchParam, setSearchParam] = useState<IOrderSearchFields>({})
    //新增详情form
    const [detailAddForm, setDetailAddForm] = useState<IOrderDetail>({})
    //编辑详情form
    const [detailEditForm, setDetailEditForm] = useState<IOrderDetail>({})
    //分页参数
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg)
    //表格多选id值
    const [selectedRowKeys, setSelectedRowKeys] = useState<IOrderDetail[]>([])
    const [SelectedId, setSelectedId] = useState('')
    //对账明细打开页面
    const [detailVisible, setDetailVisible] = useState(false)
    //新增，编辑状态判断
    const [mode, setMode] = useState<'add' | 'edit'>('add')
    const pgCfgRef = useRef<TablePaginationConfig>(initPgCfg)
    //新增详情form
    const [totalNum, setTotalNum] = useState<any>('')
    const {
        user: { shopCode, userName },
        fleetData,
        companyData,
        setLoadingInfo,
    } = useGlobalModel(({ user }) => [user])
    const [loading, setLoading] = useState<boolean>(false)
    const [companyList, setCompanyList] = useState<any[]>(['全部'].concat(companyData.map((item) => item.label)))
    const [fleetList, setFleetList] = useState<any[]>(['全部'].concat(fleetData.map((item) => item.label)))
    const [companyName, setCompanyName] = useState<string>('全部')
    const [fleetName, setFleetName] = useState<string>('全部')
    useEffect(() => {
        pgCfgRef.current = pgCfg
    }, [pgCfg])
    //列表查询
    const loadData = async (page: ISearchPage = pgCfgRef.current, searchValue: IOrderSearchFields = searchParam) => {
        if (companyList.length === 1 || fleetList.length === 1) {
            let { retData } = await fleetService.page({ type: 'company', createUserId: shopCode })
            setCompanyList(['全部'].concat(retData.map((item) => item.institutionName)))
            let { retData: list } = await fleetService.page({ type: 'fleet', createUserId: shopCode })
            setFleetList(['全部'].concat(list.map((item) => item.institutionName)))
        }
        setLoading(true)
        const searchParams = {
            ...searchValue,
            customerName: userName,
            company: companyName !== '全部' ? companyName : '',
            fleet: fleetName !== '全部' ? fleetName : '',
            pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.current || page?.pageNum) ?? DEFAULT_FIRST_PAGE_NUM,
        }
        let { retData } = await orderService.page(searchParams)
        const { records, oddCount, ...pg } = retData
        setPgCfg(transPgToPagination(pg))
        // setPgCfg(transPgToPagination({total: records.length,size: 100,current: 1,}));
        setDataSource(records)
        // let { retData:totalList } = await orderService.getTotal(shopCode);
        setTotalNum(retData?.oddCount)
        setLoading(false)
    }
    //设置搜索value
    const updateSearchParam = (updateParam: IOrderSearchFields) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }
    const exportListData = async () => {
        setLoadingInfo({ loadingVisible: true, txt: '快速导出中' })
        let ids: any = ''
        if (selectedRowKeys && selectedRowKeys.length > 0) {
            ids = selectedRowKeys.map((item) => item.customerVehicleCode as string).toString()
        }
        try {
            const searchParams = {
                ...searchParam,
                company: companyName !== '全部' ? companyName : '',
                fleet: fleetName !== '全部' ? fleetName : '',
                pageSize: -1,
                pageNum: 1,
                customerVehicleCode: ids ? ids : '',
                // id:ids?ids:'',
                // // orders: orders.current,
                // customerName:ids?'':userName,
                // customerVehicleCode:ids?'':vehicleFormVal.customerVehicleCode,
            }

            let result = await orderService.export(searchParams)
            result && setLoadingInfo({ loadingVisible: false, txt: '' })
            convertRes2Blob(result)
            // setSelectedRowKeys([])
        } catch {
            setLoadingInfo({ loadingVisible: false, txt: '' })
        }
    }
    //重置搜索参数
    const resetSearchParam = () => {
        setSearchParam({})
        setSelectedRowKeys([])
        loadData(initPgCfg, {})
    }

    return {
        /***field***/
        searchParam,
        initPgCfg,
        dataSource,
        selectedRowKeys,
        pgCfg,
        detailVisible,
        detailEditForm,
        detailAddForm,
        mode,
        SelectedId,
        settingTypeList,
        totalNum,
        loading,
        companyList,
        fleetList,
        fleetName,
        companyName,
        /***method***/
        setCompanyName,
        setFleetName,
        setFleetList,
        setCompanyList,
        setLoading,
        setTotalNum,
        setDataSource,
        setSelectedRowKeys,
        resetSearchParam,
        updateSearchParam,
        loadData,
        setDetailVisible,
        setDetailEditForm,
        setDetailAddForm,
        setMode,
        setSelectedId,
        exportListData,
        setSearchParam,
    }
})
